<script lang="ts" setup>
	import ExportButton from '@/components/generic/ExportButton.vue';
	import FavoriteToggle from '@/components/favorites/FavoriteToggle.vue';
	import FilterToggle from '@/components/generic/FilterToggle.vue';
	import PaginationComponent from '@/components/generic/PaginationComponent.vue';
	import SearchComponent from '@/components/generic/SearchComponent.vue';
	import WeekSelector from '@/components/generic/WeekSelector.vue';
	import ProductAvailability from '@/components/ProductAvailability.vue';
	import {useAvailability} from '@/store/availability.store';
	import {computed, watch} from 'vue';
	import NoResultsComponent from '@/components/NoResultsComponent.vue';
	import {useProductTableStore} from '@/store/table.store';
	import SubstitutesToggle from '@/components/substitute/SubstitutesToggle.vue';
	import {refreshAvailability, toggleRefreshAvailability} from 'dummen-shared';
	import CopyUrlButton from '@/components/generic/CopyUrlButton.vue';
	import ClearFavoritesButton from '@/components/favorites/ClearFavoritesButton.vue';
	import {storeToRefs} from 'pinia';
	import {useFavoriteProductStore} from '@/store/favorite.product.store';

	const availabilityStore = useAvailability();

	const tableStore = useProductTableStore();

	const loading = computed(() => tableStore.loading);

	const weeks = computed(() => availabilityStore.weeks);

	const products = computed(() => availabilityStore.availability ?? []);

	const shouldRefreshAvailability = computed(() => refreshAvailability.value);

	const updateData = async () => await availabilityStore.getAvailabilityResult();

	const favoriteStore = useFavoriteProductStore();

	const {favoriteViewActive} = storeToRefs(favoriteStore);

	watch(shouldRefreshAvailability, async (shouldRefresh) => {
		if (shouldRefresh) {
			await updateData();

			// Reset the refresh availability flag.
			toggleRefreshAvailability();
		}
	})
</script>

<template>
	<div class="catalog-overview">
		<div v-if="!loading" class="catalog-overview-header">
			<FilterToggle />

			<SearchComponent @search-updated="updateData" />

			<SubstitutesToggle />

			<WeekSelector v-if="weeks" :weeks="weeks" />

			<FavoriteToggle @favorites-toggled="updateData" />

			<ClearFavoritesButton v-if="favoriteViewActive" @favorites-cleared="updateData" />

			<CopyUrlButton />

			<ExportButton v-if="products.length > 0" />
		</div>

		<NoResultsComponent :loading="loading" :number-of-products="products.length" @reset-filters="updateData" />

		<template v-if="!loading && products.length > 0">
			<ProductAvailability />

			<PaginationComponent @pagination-updated="updateData" />
		</template>
	</div>
</template>
